import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex py-2 items-center" }
const _hoisted_2 = { class: "font-medium text-left" }
const _hoisted_3 = { class: "flex-grow text-right" }
const _hoisted_4 = { "data-dusk": "accordion-list" }

import { ref, watch } from 'vue';
import BaseCheckbox from '@/lib/components/Checkbox/BaseCheckbox.vue';
import BaseIcon from '@/lib/components/Icon/BaseIcon.vue';
import NumberBadge from '@/lib/components/Badge/NumberBadge.vue';
import { IPopoverOption } from '@/lib';
import { useI18n } from 'vue-i18n';
import BaseButton from '@/lib/components/Button/BaseButton.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    heading: null,
    options: null
  },
  emits: ["selectedValuesChange"],
  setup(__props: any, { emit }: { emit: ({
  (
    e: 'selectedValuesChange',
    selectedValues: Array<string>
  ): void;
}), expose: any, slots: any, attrs: any }) {





const isExpanded = ref(true);
const selectedValues = ref<Array<string>>([]);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { t } = useI18n();

watch(selectedValues, () => {
  emit('selectedValuesChange', selectedValues.value);
});

const toggleIsExpanded = () => {
  isExpanded.value = !isExpanded.value;
};

const handleClear = () => {
  selectedValues.value = [];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "flex items-center",
        "data-dusk": "heading-btn",
        onClick: toggleIsExpanded
      }, [
        _createVNode(BaseIcon, {
          class: _normalizeClass([{ 'transform rotate-90': isExpanded.value }, "stroke-1.5 transition-transform duration-300 ease-in-out ml-1 flex-shrink-0 self-start mt-1"]),
          name: "chevron-right",
          position: "left"
        }, null, 8, ["class"]),
        _createElementVNode("span", _hoisted_2, _toDisplayString(__props.heading), 1),
        (selectedValues.value.length > 0)
          ? (_openBlock(), _createBlock(NumberBadge, {
              key: 0,
              "badge-number": selectedValues.value.length,
              class: "ml-2 mr-1"
            }, null, 8, ["badge-number"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (selectedValues.value.length > 0)
          ? (_openBlock(), _createBlock(BaseButton, {
              key: 0,
              class: "px-3",
              color: "ghost",
              "data-dusk": "clear-btn",
              size: "sm",
              onClick: handleClear
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('platform.common.clear')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _withDirectives(_createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: option.id,
          class: "w-full flex flex-col"
        }, [
          _createVNode(BaseCheckbox, {
            modelValue: selectedValues.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedValues).value = $event)),
            "data-dusk": `popover-checkbox-${index}`,
            border: false,
            label: option.label,
            shadow: false,
            value: option.id,
            "checkbox-class": "ml-1 h-4 w-4",
            "text-class": "py-2 leading-5"
          }, null, 8, ["modelValue", "data-dusk", "label", "value"])
        ]))
      }), 128))
    ], 512), [
      [_vShow, isExpanded.value]
    ])
  ]))
}
}

})